var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebpos2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 145.5 145.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 21.35,
    y1: 124.15,
    x2: 124.15,
    y2: 21.35,
    gradientTransform: "translate(121.8 -17.69) rotate(73.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9748a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d163ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 39.27,
    y1: 107,
    x2: 106.48,
    y2: 39.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edbede"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 72.75,
    cy: 72.75,
    r: 72.75,
    transform: "translate(-17.69 121.8) rotate(-73.47)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.83,47.75c-1.73-2.4-5.16-4.16-9.43-5.42v-12.89c0-2.4-2.13-4.43-4.65-4.43H55.96c-2.61,0-4.65,1.95-4.65,4.43v13.02c-4.06,1.24-7.31,2.95-8.97,5.25-2.97,3.96-3.86,8.64-2.57,13.54l4.44,16.66v30.53c-.13,2.01,.55,3.92,1.9,5.38,1.41,1.53,3.38,2.37,5.55,2.37h42.62c4.16,0,7.67-3.51,7.67-7.66v-30.62l4.44-16.67c1.22-4.64,.35-9.29-2.54-13.49Zm-14.43-6.59c-3.2-.6-6.64-.98-10.07-1.19v-9.96h10.07v11.15Zm-33.1-11.15h18.03v9.78c-.43,0-.85,0-1.27,0-5.5,0-11.48,.44-16.76,1.46v-11.23Zm45.23,29.95l-4.52,16.98c-.06,.21-.08,.43-.08,.64v30.95c0,1.42-1.25,2.66-2.67,2.66H51.66c-.76,0-1.43-.27-1.88-.76-.42-.45-.62-1.06-.58-1.7,0-.06,0-.13,0-.19v-30.95c0-.22-.03-.43-.08-.64l-4.52-16.97c-.91-3.46-.34-6.48,1.76-9.29,2.11-2.93,11.97-5.89,26.7-5.89,14.74,0,24.6,2.96,26.68,5.85,2.04,2.97,2.65,6.11,1.8,9.33Zm-15.23-6.58h-26.9c-3.1,0-5.73,2.62-5.73,5.72v9.03c0,3.1,2.62,5.72,5.73,5.72h26.9c3.11,0,5.73-2.62,5.73-5.72v-9.03c0-3.1-2.62-5.72-5.73-5.72Zm.73,14.75c0,.34-.39,.72-.73,.72h-26.9c-.34,0-.73-.39-.73-.72v-9.03c0-.34,.39-.72,.73-.72h26.9c.34,0,.73,.39,.73,.72v9.03Zm-22.63,18.27c0,1.93-1.57,3.49-3.5,3.49s-3.5-1.56-3.5-3.49,1.57-3.49,3.5-3.49,3.5,1.56,3.5,3.49Zm11.84,0c0,1.93-1.57,3.49-3.5,3.49s-3.5-1.56-3.5-3.49,1.57-3.49,3.5-3.49,3.5,1.56,3.5,3.49Zm12.05,0c0,2.02-1.47,3.49-3.5,3.49s-3.5-1.66-3.5-3.49c0-2.02,1.66-3.49,3.5-3.49s3.5,1.66,3.5,3.49Zm-23.89,11.61c0,2.02-1.66,3.49-3.5,3.49-2.03,0-3.5-1.66-3.5-3.49,0-2.02,1.66-3.49,3.5-3.49,2.03,0,3.5,1.47,3.5,3.49Zm11.84,0c0,2.02-1.47,3.49-3.5,3.49s-3.5-1.66-3.5-3.49c0-2.02,1.66-3.49,3.5-3.49,2.03,0,3.5,1.47,3.5,3.49Zm12.05,0c0,2.02-1.47,3.49-3.5,3.49s-3.5-1.66-3.5-3.49c0-2.02,1.66-3.49,3.5-3.49s3.5,1.47,3.5,3.49Z",
    fill: "url(#e)",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebpos2);
export default __webpack_public_path__ + "static/media/webpos-2.e79cfdca4b0ef43d0def04c12e4fdd61.svg";
export { ForwardRef as ReactComponent };